module.exports = __webpack_public_path__ + "img/trophy.efcff036.png";